export default {
  success: {
    edit: '{title} با موفقیت ویرایش شد',
    delete: '{title} با موفقیت حذف شد'
  },
  confirm: {
    delete: {
      title: 'حذف {title}',
      message: 'آیا از حذف {title} اطمینان دارید؟'
    }
  },
  startShipping: {
    title: 'شروع حمل بار',
    message: 'آیا از شروع این بار اطمینان دارید؟',
    success: 'شروع حمل با با موفقیت ثبت شد'
  },
  acceptOffer: {
    title: 'قبول پیشنهاد',
    message: 'آیا از قبول این پیشنهاد اطمینان دارید؟',
    success: 'پیشنهاد با موفقیت قبول شد'
  },
  cancelOrder: {
    title: 'لغو سفارش',
    message: 'آیا از لغو این سفارش اطمینان دارید؟',
    success: 'سفارش با موفقیت لغو شد'
  },
  reachOrigin: {
    message: 'آیا به مبدا رسیدید؟',
    success: 'رسیدن به مبدا با موفقیت ثبت شد'
  },
  loading: {
    message: 'آیا بارگیری به اتمام رسید؟',
    success: 'بارگیری با موفقیت ثبت شد'
  },
  received: {
    message: 'آیا تحویل به اتمام رسید؟',
    success: 'تحویل با موفقیت ثبت شد'
  },
  reachDestination: {
    message: 'آیا به  {destination} رسیدید؟',
    success: 'رسیدن به  {destination} با موفقیت ثبت شد'
  },
  discharge: {
    message: 'آیا تخلیه بار به اتمام رسید؟',
    success: 'تخلیه بار با موفقیت انجام شد'
  },
  delivered: {
    message: 'آیا تحویل بار به اتمام رسید؟',
    success: 'تحویل بار با موفقیت انجام شد'
  },
  skip: {
    message: 'آیا از این اقدام مطمئنی؟',
    success: 'تحویل مرسوله ناموفق بود'
  },
  passwordChangedSuccessfully: 'رمز عبور با موفقیت تغییر کرد',
  passwordCreatedSuccessfully: 'رمز عبور با موفقیت ساخته شد',
  error404: 'صفحه مورد نظر وجود ندارد!',
  unavailableDescription: "شما در حالت 'عدم سرویس دهی' هستید!",
  deliveryCodeSentSuccessfully: 'کد تحویل با موفقیت ارسال شد',
  serviceStateSetToAvailable: "وضعیت سرویس دهی به 'آماده سرویس دهی' تغییر یافت",
  acceptConditions: 'شرایط و قوانین بادپا قبول شد'
}
